<template>
  <a
    v-if="value"
    :href="linkType + ':' + value"
    @click.stop
    class="text-decoration-none"
  >
    {{ formattedValue }}
  </a>
</template>

<script>
export default {
  name: "contact-link",
  props: {
    value: {
      type: String,
      default: null,
    },
    linkType: {
      type: String,
      default: "tel",
      validator: (value) => ["tel", "mailto"].includes(value),
    },
    formatPhone: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    formattedValue() {
      if (!this.value) return "";
      if (this.linkType === "tel" && this.formatPhone) {
        return this.phoneNumberFormatter(this.value);
      }
      return this.value;
    },
  },
  methods: {
    phoneNumberFormatter(number) {
      // Entfernt zuerst alle Leerzeichen, um eine einheitliche Basis zu schaffen
      number = number.replace(/\s+/g, "");

      // Überprüft und formatiert internationale Vorwahlen (+49 oder 0049)
      number = number.replace(/(\+49|0049)/, "$1\u00A0");

      // Formatierung für Mobilnummern (0000 123456)
      if (number.match(/(\+49|0049)?\d{10}/)) {
        return number.replace(/(\d{4})(\d{6})/, "$1\u00A0$2");
      }
      // Anpassung der Logik für Festnetznummern, um korrekt mit Nummern umzugehen, die weniger als 11 Ziffern haben
      else if (number.match(/(\+49|0049)?\d{7,}/)) {
        // Überprüft, ob die Nummer genau 10 Ziffern hat, und wendet eine spezielle Formatierung an
        if (number.replace(/(\+49|0049)\s?/, "").length === 10) {
          return number.replace(/(\d{4})(\d+)/, "$1\u00A0$2");
        } else {
          // Standardformatierung für Festnetznummern mit mehr oder weniger als 10 Ziffern
          return number.replace(/(\d{3})(\d+)/, "$1\u00A0$2");
        }
      }
      // Gibt die Nummer unverändert zurück, falls sie keinem Muster entspricht
      return number;
    },
  },
};
</script>
